import {Context} from 'react'
import {typedConnect} from '../../../../../commons/components/runtime-context/connect'
import {RuntimeContext} from '../../../../../commons/components/runtime-context/runtime-context'
import {AppProps} from '../app/interfaces'

export const WidgetRuntimeContext: Context<AppProps> = RuntimeContext

export const connect = typedConnect<AppProps>()
